import useGetModelsList from '@/services/api/model/useGetModelsList'

/**
 * A stable string that changes exactly when the set of *enabled* What-If
 * models changes. Toggling a model is a server-side mutation (flips
 * `is_enabled`) with no query param of its own — every dashboard query that
 * uses `staleTime: Infinity` must fold this into its queryKey, or a toggle
 * won't refetch and the page keeps serving pre-toggle numbers.
 */
export default function useModelsFingerprint() {
  const { data: models } = useGetModelsList()

  return (models ?? [])
    .filter((model) => model.is_enabled)
    .map((model) => model.id)
    .sort((a, b) => a - b)
    .join(',')
}
